import { WalletType } from '@/context/types';

export type WalletConnectionPurpose = 'vault' | 'analytics' | 'quanta-login' | 'quanta-register' | 'general';

export const canPerformVaultActions = (walletType: WalletType | null | undefined): boolean => walletType === WalletType.Metamask;
export const canRegisterQuanta = (walletType: WalletType | null | undefined): boolean => walletType === WalletType.Metamask;

export function walletsForPurpose(purpose: WalletConnectionPurpose): WalletType[] {
  return purpose === 'quanta-login' ? [WalletType.Metamask, WalletType.Xverse, WalletType.Unisat] : [WalletType.Metamask];
}

export function connectionPurposeForPath(pathname: string): WalletConnectionPurpose {
  if (pathname === '/quanta' || pathname.startsWith('/quanta/')) return 'quanta-login';
  if (pathname === '/overview' || pathname.startsWith('/overview/')) return 'analytics';
  if (pathname === '/' || pathname === '/liquidations' || pathname === '/liquidations/claim' || pathname.startsWith('/liquidations/claim/'))
    return 'vault';
  // Outside Quanta, every connection surface goes straight to MetaMask.
  // Transaction authorization remains enforced independently of the current route.
  return 'general';
}
